import React from 'react';
import { Box, Stepper, Step, StepLabel, Icons } from '@curves/ui-base';

/**
 * 流程步驟條（可塞入 MainLayout Header 自訂內容插槽）
 * 顯示多步驟進度，右側可選擇性提供「上一頁」返回鈕。
 *
 * @param {string[]} steps - 步驟文字陣列
 * @param {number} activeStep - 目前步驟索引（0 起算）
 * @param {() => void} [onBack] - 有提供時於右側顯示「上一頁」鈕，點擊觸發此回呼
 */
const FlowStepper = ({ steps = [], activeStep = 0, onBack }) => (
    <Box className="flow-stepper">
        {onBack && (
            <button type="button" className="flow-stepper__back" onClick={onBack}>
                <Icons.KeyboardArrowLeft />
            </button>
        )}
        <Stepper activeStep={activeStep} alternativeLabel className="flow-stepper__steps">
            {steps.map((label) => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    </Box>
);

export default FlowStepper;
